import { useTranslation } from 'react-i18next'
import { imageUrl } from 'app/frontend/base/helpers'
import { RaidPlanAssignmentType } from 'app/frontend/types/custom/RaidPlan'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import {
  getEffectiveAssignmentType,
  isInterruptAssignmentType,
} from './assignmentTimeline'

type Props = {
  assignmentType?: RaidPlanAssignmentType
}

const ASSIGNMENT_TYPE_LABEL_KEY: Record<
  Exclude<RaidPlanAssignmentType, 'general'>,
  string
> = {
  interrupt: 'interrupt',
  ranged_interrupt: 'ranged-interrupt',
  melee_interrupt: 'melee-interrupt',
}

const AssignmentTypeIcon = ({ assignmentType }: Props) => {
  const { t } = useTranslation()
  const effectiveType = getEffectiveAssignmentType(assignmentType)
  if (!isInterruptAssignmentType(effectiveType)) return null
  const label = t(
    `dashboard.team.plans.assignments.assignment-types.${ASSIGNMENT_TYPE_LABEL_KEY[effectiveType]}`,
  )

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <img
          src={imageUrl('ej-icons/interrupt_icon.png')}
          alt={label}
          className='w-5 h-5 shrink-0'
        />
      </TooltipTrigger>
      <TooltipContent className='text-sm pointer-events-none'>
        {label}
      </TooltipContent>
    </Tooltip>
  )
}

export default AssignmentTypeIcon
